<template>
    <!-- Sidebar -->
      <div id="sidebar-wrapper">
        <ul class="sidebar-nav nav-pills nav-stacked" id="menu">
          <li id="homeLink">
            <!-- <a href="#"><span class="fa-stack fa-lg pull-left"> <i class="fa fa-home fa-stack-1x "></i></span>Home</a> -->
            <router-link v-bind:to="{ path:'/closeticket'}" href="#">
              <span class="fa-stack fa-lg pull-left"> <i class="fa fa-home fa-stack-1x "></i></span>Home
            </router-link>

          </li>
          <template v-if="$store.getters.role_name == 'super admin' || $store.getters.role_name == 'admin' || $store.getters.role_name == 'manager'">
            <li id="reportLink">
              <!-- <router-link v-bind:to="{ path:'/reports'}" href="#">
                <span class="fa-stack fa-lg pull-left"> <i class="fa fa-file fa-stack-1x "></i></span>Reports
              </router-link> -->
              <label class="tree-toggle nav-header"><span class="fa-stack fa-lg pull-left"> <i class="fa fa-bell fa-stack-1x "></i></span>Reports <i class="arrow-handle fa fa-angle-down" aria-hidden="true"></i>
              <!-- <i class="arrow-handle fa fa-angle-up" aria-hidden="true"></i>-->
              </label>
              <ul class="nav nav-list tree">
                    <li><router-link v-bind:to="{name: 'HourlyReport'}">Hourly Report</router-link></li>
                    <li><router-link v-bind:to="{name: 'ListTicket'}">All Tickets</router-link></li>
                    <li><router-link v-bind:to="{name: 'FilteredListTicket'}">Store wait times</router-link></li>
                    <li><router-link v-bind:to="{name: 'TicketPerDay'}">User Tickets</router-link></li>
              </ul>
            </li>
            <template v-if="$store.getters.role_name == 'super admin' || $store.getters.role_name == 'admin' || $store.getters.role_name == 'manager'">
              <li id="locationLink">
                <router-link v-bind:to="{ path:'/location'}" href="#">
                  <span class="fa-stack fa-lg pull-left"> <i class="fa fa-map-marker fa-stack-1x "></i></span>Location
                </router-link>
              </li>

              <li id="stationLink">
                <label class="tree-toggle nav-header"><span class="fa-stack fa-lg pull-left"> <i class="fa fa-location-arrow fa-stack-1x "></i></span>Stations <i class="arrow-handle fa fa-angle-down" aria-hidden="true"></i></label>
                <ul class="nav nav-list tree">
                  <li><router-link v-bind:to="{name: 'ListStationLocation'}">List Location Stations</router-link></li>
                  <li><router-link v-bind:to="{name: 'ListStations'}">List Stations</router-link></li>
                </ul>
              </li>
            </template>
          </template>

          <template v-if="$store.getters.role_name == 'super admin' || $store.getters.role_name == 'admin'">
          <li id="userLink">
            <router-link v-bind:to="{ path:'/listuserlocation'}" href="#">
              <span class="fa-stack fa-lg pull-left"> <i class="fa fa-user fa-stack-1x "></i></span>Users
            </router-link>
          </li>
          </template>

          <template v-if="$store.getters.role_name == 'super admin' || $store.getters.role_name == 'admin' || $store.getters.role_name == 'manager' || $store.getters.role_name == 'tvscreen'">
            <li id="tvScreenLink">
              <router-link v-bind:to="{ path:'/tvscreen'}" href="#">
                <span class="fa-stack fa-lg pull-left"> <i aria-hidden="true" class="fa fa-film fa-stack-1x"></i></span>TV Screen
              </router-link>
            </li>
          </template>
         
          

          <!--<li id="ticketLink">-->
            <!--<router-link v-bind:to="{ path:'/ticketperday'}" href="#">-->
              <!--<span class="fa-stack fa-lg pull-left"> <i class="fa fa-ticket fa-stack-1x "></i></span>Ticket-->
            <!--</router-link>-->
          <!--</li>-->

          <!--<li id="avgTicketTime">-->
            <!--<router-link v-bind:to="{ path:'/avgtickettime'}" href="#">-->
              <!--<span class="fa-stack fa-lg pull-left"> <i class="fa fa-ticket fa-stack-1x "></i></span>Avg Ticket Time-->
            <!--</router-link>-->
          <!--</li>-->

          <!-- <li id="listTicketLink">
            <router-link v-bind:to="{ path:'/reports'}" href="#">
              <span class="fa-stack fa-lg pull-left"> <i class="fa fa-file fa-stack-1x "></i></span>Reports
            </router-link>
          </li> -->
        </ul>
      </div>
      <!-- Sidebar -->
</template>

<script>
    import Vue from 'vue';
    import {HTTP} from '../http-common';
    import EventBus from "../components/event-bus";
    
    var self;

    export default {
        name: 'Center',
        components: {
            
        },
        data() {
            return {
              
            }
        },
        beforeMount: function () {
          self = this;
        },
        mounted: function () {
            $("#menu-toggle").click(function(e) {
              e.preventDefault();
              console.log('.menu-toggle click');
              $("#wrapper").toggleClass("toggled");
            });
            $("#menu-toggle-2").click(function(e) {
                e.preventDefault();
                console.log('.menu-toggle 2 click');
                $("#wrapper").toggleClass("toggled-2");
                $('#menu ul').hide();
            });

            $('#menu ul').hide();
            $('#menu ul').children('.current').parent().show();
            $('#homeLink').addClass('active');

            $('#menu').on("click", "li > a", function(event) {
              $("#menu li").removeClass("active");
              $(this).parent().addClass('active');
              $(this).addClass('active');
              $(this).parent().parent().parent().addClass('active');
            });

            $('#menu').on("click", "li > label", function(event) {
              if(!$(this).parent().children('ul.tree').is(':visible')) {
                  $(this).children('.arrow-handle').removeClass('fa-angle-down');
                  $(this).children('.arrow-handle').addClass('fa-angle-up');
              } else {
                  $(this).children('.arrow-handle').removeClass('fa-angle-up');
                  $(this).children('.arrow-handle').addClass('fa-angle-down');
              }
              $(this).parent().children('ul.tree').toggle(200);
            });


        },
        methods: {
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/Sidebar.vue